module.exports = __webpack_public_path__ + "static/media/league-logo.3e74ccf3.svg";